import React from 'react';
import './AdminFooter.css';

function AdminFooter({ companyName }) {
  return (
    <footer id='admin-footer'>
      <p className='copyrightFooter'>
        ©Copyright {new Date().getFullYear()} {companyName} <br /> E-Raffle
      </p>
      <div className='logo-container'>
        Powered by
        <a
          href='https://gotasoft.io/'
          target='_blank'
          rel='noopener noreferrer'
          title='Powered by Gotasoft'
        >
          <img src='/logoFooter.svg' className='img-fluid' alt='Gotasoft logo' />
        </a>
      </div>
    </footer>
  );
}

export default AdminFooter;
